import processEnvPublic from 'unlikely-env/public'
import Storyblok, { pageSbParams } from '~/lib/storyblok'
import { STORYBLOK_TYPES } from '~/lib/storyblok-types'

import { getLang } from '~/utils/locales'

/**
 * It fetches a list of stories by their linked shopify product using plugin field
 * @param {string[]} ids - An array of base64 encoded shopify gids.
 * @param {any} [params] - {
 * @returns An array of stories
 */
export default async function getStoryblokProductsFromShopifyIds(
  ids: string[],
  locale: string,
  sbParams?: Record<string, any>,
): Promise<any[]> {
  if (!Array.isArray(ids)) {
    console.error('getStoryblokProductsFromShopifyIds: ids must be an array')
    return null
  }

  try {
    const filterQuery = {}
    // Find story which have the specific shopify id in relation
    // items.${id} allows to reach a specific index in a storyblok array of data
    filterQuery[`shopify_product.data.id`] = {
      in: ids.map((id) => id)?.join(','),
    }

    const fetchData =
      ids?.length > 0
        ? await Storyblok.get(`cdn/stories/`, {
            filter_query: filterQuery,
            language: getLang(locale),
            starts_with: `${processEnvPublic('NEXT_PUBLIC_PROJECT_NAME')}/${
              STORYBLOK_TYPES.PRODUCT
            }/`,
            version: 'published',
            ...(pageSbParams?.instance ?? {}),
            ...(sbParams ?? {}),
          })
        : null

    return fetchData?.data?.stories ?? []
  } catch (error) {
    console.error(error)
  }
}

export function arrayToObjUuid<T extends { uuid: string }>(
  array: T[],
): Record<string, T> {
  return array.reduce((acc, item) => {
    if (item?.uuid) acc[item.uuid] = item
    return acc
  }, {})
}
